import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

function PrimaryCard({
  description = null,
  primaryTitle = null,
  URL = "",
  poster,
  minHeight = 500,
  className = "",
  extraContent = null,
  containerClassName = "",
  ...rest
}) {
  return (
    <div className={clsx(containerClassName)}>
      <div
        className={clsx(
          "flex items-end bg-cover bg-bottom bg-no-repeat mb-5 p-[12px] sm:p-[24px] pb-0",
          className,
        )}
        {...rest}
        style={{ backgroundImage: `url(${poster})` }}
      >
        <div>
          <h2 className="text-28px font-bold uppercase">{primaryTitle}</h2>
          <p className="mb-[12px] mt-[16px] max-w-[800px] text-14px">{description}</p>
        </div>
      </div>
      {extraContent}
    </div>
  );
}

export default PrimaryCard;

PrimaryCard.propTypes = {
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  URL: PropTypes.string,
  poster: PropTypes.string,
  minHeight: PropTypes.number,
  extraContent: PropTypes.node,
};
